/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'license-list';
const prefix = `${moduleName}.${componentName}`;

export const licensesHeader = `${prefix}.licensesHeader`;
export const columnTitleType = `${prefix}.columnTitleType`;
export const columnTitleLicenseId = `${prefix}.columnTitleLicenseId`;
export const columnTitleServiceUnits = `${prefix}.columnTitleServiceUnits`;
export const columnTitleExpiry = `${prefix}.columnTitleExpiry`;
export const actionTitleDelete = `${prefix}.actionTitleDelete`;
export const expiredLabel = `${prefix}.expiredLabel`;
export const columnTitleDescription = `${prefix}.columnTitleDescription`;
export const columnTitleTier = `${prefix}.columnTitleTier`;
export const columnTitleServiceCores = `${prefix}.columnTitleServiceCores`;
export const columnTitleSeSockets = `${prefix}.columnTitleSeSockets`;
export const seVCpus = `${prefix}.seVCpus`;
export const licensesDeletedMsg = `${prefix}.licensesDeletedMsg`;
export const refreshLicensesButtonLabel = `${prefix}.refreshLicensesButtonLabel`;
export const addLicenseKeyLabel = `${prefix}.addLicenseKeyLabel`;
export const legacyLicenseExpiryAlert = `${prefix}.legacyLicenseExpiryAlert`;
export const learnMoreLabel = `${prefix}.learnMoreLabel`;

export const ENGLISH = {
    [licensesHeader]: 'Licenses',
    [columnTitleType]: 'Type',
    [columnTitleLicenseId]: 'License ID',
    [columnTitleServiceUnits]: 'Service Units',
    [columnTitleExpiry]: 'Expiry',
    [actionTitleDelete]: 'Delete',
    [expiredLabel]: 'Expired',
    [columnTitleDescription]: 'Description',
    [columnTitleTier]: 'Tier',
    [columnTitleServiceCores]: 'Service Cores',
    [columnTitleSeSockets]: 'Service Engine Sockets',
    [seVCpus]: 'SE vCPUs',
    [licensesDeletedMsg]: '{0} license(s) deleted successfully',
    [refreshLicensesButtonLabel]: 'Refresh Licenses',
    [addLicenseKeyLabel]: 'Add License Key',
    [legacyLicenseExpiryAlert]: 'All legacy licenses are scheduled to expire on {0} (in {1} day(s))',
    [learnMoreLabel]: 'Learn More',
};
